import { ModalProps } from 'antd';
import { AttachDonorsModalPropTypes } from 'modules/donor/types';
import { useState } from 'react';

import { ContextType } from './type';

export const useProviderValue = (): ContextType => {
  const [modalProps, setModalProps] = useState<
    ModalProps & AttachDonorsModalPropTypes
  >();
  const [visible, setVisible] = useState(false);

  const showModal = (params?: AttachDonorsModalPropTypes) => {
    params && setModalProps({ ...modalProps, ...params });
    setVisible(true);
  };

  const updateModalProps = (props: ModalProps & AttachDonorsModalPropTypes) => {
    setModalProps(props);
  };

  const hideModal = () => {
    setVisible(false);
  };

  return {
    modalConfig: {
      teamId: '',
      ...modalProps,
      visible,
      hide: hideModal,
    },
    showModal,
    hideModal,
    updateModalProps,
  };
};
